import Button from '@/components/Button/Button';
import { useIsStoreCartSetupDisabled } from '@/hooks/useIsStoreCartSetupDisabled';

interface IStoreCartSetupButtonProps {
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  onClick: () => void;
  isLoading?: boolean;
}

const StoreCartSetupButton: React.FC<IStoreCartSetupButtonProps> = ({
  className,
  iconClassName,
  labelClassName,
  onClick,
  isLoading = false,
}) => {
  const isDisabled = useIsStoreCartSetupDisabled();

  return (
    <Button
      className={className}
      iconClassName={iconClassName}
      labelClassName={labelClassName}
      iconOnRightSrc="/src/assets/svg/double_arrow.svg"
      onClick={onClick}
      disabled={isDisabled || isLoading}
    >
      Set Up the Store
    </Button>
  );
};

StoreCartSetupButton.displayName = 'StoreCartSetupButton';

export default StoreCartSetupButton;
